<template>
    <div>
        <multi-select :options="options"
                      @search-change="asyncQuery"
                      :internal-search="false"
                      :placeholder="placeholder"
                      v-model="resource"
                      :loading="isLoading">
            <template slot="singleLabel" slot-scope="{ option }">
                <span class="option__desc">
                    <span class="option__title">{{ option.title }}</span>
                </span>
            </template>
            <template slot="option" slot-scope="{ option }">
                <div class="option__desc">
                    <span class="option__title">{{ option.title }}</span>
                </div>
            </template>
            <template slot="noResult">
                {{ $t('No results found') }}
            </template>
            <template slot="noOptions">
                {{ $t('Start searching by typing') }}
            </template>
        </multi-select>
    </div>
</template>
<script>
    import MultiSelect from 'vue-multiselect'
    import axios from 'axios';
    import qs from 'qs';

    export default {
        components: {MultiSelect},
        props: {
            multiple: {
                default: false
            },
            url: {
                required: true
            },
            value: {},
            name: {
                default: 'resources'
            },
            placeholder: {
                default: 'Start typing to search'
            },
            filters: {
                type: Object
            }
        },
        data() {
            return {
                options: [],
                isLoading: false,
                resource: this.value
            }
        },
        methods: {
            asyncQuery(queryString) {
                if (!queryString) {
                    return;
                }

                this.isLoading = true;
                this.makeRequest(queryString);
            },
            makeRequest: _.debounce(function (queryString) {
                axios.get(
                    this.url
                    + '?'
                    + qs.stringify({
                        filters: Object.assign(this.filters || {}, {
                            query: queryString,
                            without: _.map(this.resource, 'id')
                        })
                    })
                ).then((resp) => {
                    this.isLoading = false;
                    this.options = resp.data.data;
                })
                .catch(() => this.isLoading = false)
            }, 500)
        },
        watch: {
            resource() {
                this.$emit('input', this.resource);
            }
        }
    }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
